export const BASE_URL =
    (process.env.REACT_APP_API_ROOT_DATUM || process.env.REACT_APP_API_ROOT_DEFAULT) + '/datum/';

export const urls = {
    configs: BASE_URL + 'configs/',
    config_details: BASE_URL + 'configs/:id/',
    config_duplicate: BASE_URL + 'configs/:id/duplicate/',

    program_config: BASE_URL + 'configs/by_program/:id/',
};
